module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30.667 0h-12c-1.475 0-1.824.843-.781 1.885l4.229 4.229-16.005 16-4.227-4.229C.84 16.842 0 17.192 0 18.666v12a1.33 1.33 0 0 0 1.328 1.333h12c1.475 0 1.824-.843.781-1.885L9.88 25.885l16.005-16 4.229 4.229c1.043 1.043 1.885.693 1.885-.781v-12C31.999.597 31.402 0 30.666 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/maximize-3.js
// module id = 1264
// module chunks = 14